import { get } from 'lodash'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { MobileServiceFormComponent } from './MobileServiceForm'
import { IUploadedFile } from './UploadDocumentsStep'

export const formName = 'mobileService'
const stateToProps = ({ auth, form }, { change }) => ({
  formData: get(form, `${formName}.values`, {}),
  isLoggedIn: !!(auth.token && auth.user.id),
  initialValues: {
    ban: '',
    number: '',
    uploadedFiles: [],
    isLoading: false,
    isPremiumNumber: false,
    endUserType: '',
    premiumNumberPrice: 0,
    confirmFees: false,
  },
  clearNumber: () => change('number', ''),
})

const dispatchToProps = dispatch => ({
  dispatch,
})

interface IFormData {
  ban: string
  number: string
  uploadedFiles: IUploadedFile[]
  isLoading: boolean
  isPremiumNumber: boolean
  endUserType: 'individual' | 'business'
  premiumNumberPrice: number
  confirmFees: boolean
}

export interface IMobileServiceFormProps {
  onCancel: Function
  setHeadings: Function
}

export interface IMobileServiceFormDispatchProps {
  formData: IFormData
  isLoggedIn: boolean
  dispatch: Function
  clearNumber: Function
}

export interface IStepCommonProps {
  formData: IFormData
  change: Function
  onBack: Function
  loading: boolean
  setHeadings: Function
}

export const MobileServiceForm = connect(
  stateToProps,
  dispatchToProps
)(
  reduxForm<IFormData, IMobileServiceFormProps & IMobileServiceFormDispatchProps>({
    form: formName,
  })(MobileServiceFormComponent)
)



// WEBPACK FOOTER //
// src/features/MobileServices/MobileServiceForm/MobileServiceForm.container.ts